import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { useFlow } from "../context/FlowContext";
import { Reveal } from "./motion";
import { IMAGES } from "../assets";

export const Profesionales = () => {
  const { t } = useLang();
  const { openPro } = useFlow();
  const s = t.prosSection;
  return (
    <section id="pros" className="relative bg-cream py-24 md:py-32 scroll-mt-24" data-testid="pros">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <Reveal><span className="text-xs font-semibold uppercase tracking-[0.2em] text-petrol">{s.eyebrow}</span></Reveal>
            <Reveal delay={0.05}><h2 className="mt-4 font-heading text-4xl md:text-5xl font-light tracking-tight text-ink leading-[1.1]">{s.title}</h2></Reveal>
            <Reveal delay={0.1}><p className="mt-6 text-lg text-ink-soft leading-relaxed max-w-xl">{s.body}</p></Reveal>
            <ul className="mt-8 space-y-3">
              {s.benefits.map((b, i) => (
                <motion.li key={i} initial={{ opacity: 0, x: -16 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.06 }} className="flex items-center gap-4" data-testid={`pro-benefit-${i}`}>
                  <span className="w-7 h-7 rounded-full bg-sage-light flex items-center justify-center text-sage-dark shrink-0"><Check size={15} strokeWidth={3} /></span>
                  <span className="text-ink font-medium">{b}</span>
                </motion.li>
              ))}
            </ul>
            <Reveal delay={0.1} className="mt-10">
              <button onClick={openPro} className="group inline-flex items-center gap-2 rounded-full bg-petrol text-white font-semibold px-7 py-4 hover:opacity-90 transition-all duration-300 hover:-translate-y-1" data-testid="pros-cta">
                {s.cta}
                <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="order-first lg:order-last">
            <div className="relative rounded-[2rem] overflow-hidden h-[380px] md:h-[560px] shadow-[0_24px_50px_rgb(3,33,42,0.12)]">
              <img src={IMAGES.pro} alt="Profesional de confianza de HomeHealthy" className="w-full h-full object-cover object-top" data-testid="pros-image" />
              <div className="absolute inset-0 bg-gradient-to-t from-sage-deep/20 to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
